module.exports = __webpack_public_path__ + "img/local-installers.eb558c4c.svg";